import { render, staticRenderFns } from "./PasswordRetrieval.vue?vue&type=template&id=48ce85a0&scoped=true"
import script from "./PasswordRetrieval.vue?vue&type=script&lang=js"
export * from "./PasswordRetrieval.vue?vue&type=script&lang=js"
import style0 from "./PasswordRetrieval.vue?vue&type=style&index=0&id=48ce85a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce85a0",
  null
  
)

export default component.exports